<div class="divcontent">
  <div style="text-align: end">
    <mat-icon class="closeModal" [mat-dialog-close]>cancel</mat-icon>
  </div>
  <h2>Agregar comentario</h2>
  <mat-form-field appearance="outline" class="col-12">
    <mat-label>Comentario</mat-label>
    <textarea matInput placeholder="Comentario..." [(ngModel)]="comment"></textarea>
  </mat-form-field>
  <div style="text-align: center">
    <button [disabled]="!comment" class="primary-btn rounded" mat-raised-button (click)="sendCommnet()">
      Confirmar
    </button>
  </div>
</div>